module.exports = __webpack_public_path__ + "img/xiao-liu.e672dfef.png";